import { connect } from 'react-redux';
import PembatalanMutasiKeluar from '../../../views/Student/DataSiswa/PembatalanMutasiKeluar.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';
import {
  getParamOptions, getStudentOptions, getStudentMoveOptions, getPeriodsOptions,
} from '../../../states/thunks/options.thunk';
import { listMoveRecord, activatedMoveRecord } from '../../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
    getStudentOptions: payload => dispatch(getStudentOptions(payload)),
    getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
    handleListMoveRecord: (payload, goback) => dispatch(listMoveRecord(payload, goback)),
    handleactivatedMoveRecord: (payload, goback) => dispatch(activatedMoveRecord(payload, goback)),
    getStudentMoveOptions: payload => dispatch(getStudentMoveOptions(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PembatalanMutasiKeluar);
